import React from "react";
import AwardFormPage from "../components/awards/AwardFormPage";

const AwardCreate = () => <AwardFormPage mode="create" />;

export default AwardCreate;
